module.exports = __webpack_public_path__ + "img/finder.66de6593.webp";